<template>
    <section class="single-product-sec" v-if="content">
        <div class="container">
            <swiper
                class="swiper-viewed_products swiper swiper-initialized swiper-horizontal product-row firm-sec_row product-mob-slider swiper-backface-hidden "
                :modules="modules"
                :slidesPerView="1"
                :space-between="15"
                :pagination="{ clickable: true }"

            >

                <swiper-slide class="swiper-slide product" v-for="(card, cardIndex) in content.cards" :key="card.id">
                    <div class="single-product-sec__element_wrapper">
                        <a :href="card.slug"
                                     class="single-product-sec__img_container"
                                     @click="onSelectItem(card, cardIndex)">
                            <picture>
                                <source :srcset="card.img_first.webp"
                                        type="image/webp">
                                <img :src="card.img_first.jpeg" alt=""
                                     class="single-product-sec__img"></picture>
                        </a>

                        <div class="single-product-sec__info">
                            <div class="sec-title-container">
                                <p class="sec-title-container__dop-text">{{ card.title }}</p>
                                <p class="sec-title-container__dop-text">{{ card.text }}</p>
                                <a class="sec-title product__title-link"
                                             :href="card.slug"
                                             @click="onSelectItem(card, cardIndex)">{{ card.name }}
                                </a>

                                <p class="sec-title-container__subtitle"></p>
                                <p class="hidemob">{{ card.description }}</p>
                                <p></p>
                                <div class="single-product-sec__price-row">
                                    <template v-if="card.price_old">

                                        <p class="product__sale-price product__text-def" style="margin-right: 8px">
                                            {{ card.offer.price_str }} {{ card.signs }}</p>
                                        <p class="product__old-price ">{{ card.offer.price_old_str }} {{ card.signs }}</p>
                                    </template>

                                    <p class="  product__text-def " v-if="!card.offer.price_old_str">{{ card.offer.price_str }}
                                        {{ card.signs }}</p>


                                </div>
                                <div class="single-product-sec__btn-row" style="position: relative">

                                    <button @click.prevent="addBasketCard(card)" :disabled="card.offers.length == 0" id="add-to-cart-button-js" class="btn btnV2">
                                        {{ trans('add to basket') }}
                                    </button>
                                    <div @click.prevent="updateLike(card)" class="add-like "  v-if="checkFavourites(card)"
                                         :class="card.favourites ? 'active-like' : '' ">
                                        <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round">

                                            </path>
                                        </svg>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </swiper-slide>


            </swiper>


        </div>
        <div class="air-container  air-container-subscribe-pop air-container_active" v-if="air_size " @click="air_size =false">
            <div class="popup-air  popup-air_active">

                <div class="select-size product__size-selector">
                    <div class="select-size__header select-active flex-box ">
                        <p class="select-size__header-title">
                            {{trans('Choose a size')}} </p>
                        <span class="close" @click="air_size = false"><img src="http://batnorton.vue/img/svg/close-grey.svg" alt=""></span>
                    </div>
                    <div class="select-size__body select-size__body_displayed">
                        <ul class="list select-size__list">
                            <li class="list__element select-size__element" v-for="offer in current_card.offers" @click.prevent="setSize(current_card,offer)">
                                <span class="select-size__element-value">{{ offer.size.code }}</span>
                                <span class="select-size__element-value">{{current_card.remains}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {Navigation, Pagination} from 'swiper/modules';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';
import { selectItem, viewItemList } from '../../services/ga4Ecommerce.js';

// Import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import 'swiper/css';
// import 'swiper/swiper-bundle.css';
export default {
    props: {
        content: {
            type: Object,
        },


    },
    components: {

        Swiper,
        SwiperSlide,


    },
    data() {
        return {
            modules: [Navigation, Pagination],
            air_size: false,
            current_card: null,

        }
    },
    mounted() {

    },
    name: "single-product-sec",
    watch: {
        content: {
            immediate: true,
            handler(content) {
                if (content?.cards?.length) {
                    viewItemList(content.cards, 'home_single', 'Hit of sales')
                }
            },
        },
    },

    methods: {
        setSize(card,offer){
            card.offer = offer
            card.offer_show = false
            this.air_size  = false
            this.$parent.$parent.$refs.header.createBasket(card)

        },
        addBasketCard(card){
            if(card.offers.length > 1){
                this.current_card  = card
                card.offer_show  = !card.offer_show
                this.air_size  = !this.air_size

            }else{
                this.$parent.$parent.$refs.header.createBasket(card)
            }


        },
        checkFavourites(card){

            if (this.$store.state.settings.basket.favourites.find(it => it.card_id === card.id)) {

                card.favourites = true
            }
            return true
        },

        updateLike(card) {
            card.favourites = !card.favourites
            this.$parent.$parent.$refs.header.updateLike(card)
        },
        onSelectItem(card, index) {
            selectItem(card, 'home_single', 'Hit of sales', index + 1)
        },
    },
}
</script>

<style scoped>
/*.product__size-selector {*/

/*    top: 50px;*/

/*}*/
.product__size-selector {
    position: relative;
    top: 0px;
}
.select-size {
    margin-top:0;
    width: 100%;
}
</style>
